// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TicketChat-Main-Container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.TicketChat-Container {
  display: flex;
  width: 100%;
  height: calc(100vh - 97px);
  overflow: hidden;
}
.TicketChat-Main-HeaderContainer {
  padding: 0px 0px 0px 24px;
  border-bottom: 1px solid #e5e9ec;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(15px);
  flex-shrink: 0;
}

.TicketMessageInput-Container-MainScreen {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.TicketChat-Main-UpperSection {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.TicketChat-upperright {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.TicketChat-upperright span {
  color: #405261;
  font-size: 14px;
  font-weight: 400;
  line-height: 12px; /* 85.714% */
}
.TicketArrow-Container {
  margin-left: 24px;
  display: flex;
  gap: 16px;
  cursor: pointer;
}
.TicketHeading-Container {
  margin-top: 12px;
}
.Ticketguy-heading {
  color: #061522;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 29px;
}
.TicketKenzi {
  margin-top: 8px;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 85.714% */
}
.TicketHeading-SecondContainer {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  padding-right: 32px;
}
.TicketOpen-container {
  border-radius: 5px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  padding: 7px 9px;
  height: 27px;
}

.TicketHeadingOpen-Container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.TicketHeadingOpen-Container span {
  color: #061522;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 80% */
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}
.ChatTicketLogo-Container {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
}
.TicketPublicMenu-Container {
  position: absolute;
  right: 0%;
  width: 184px;
  top: 120%;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 8px 11px;
  z-index: 1;
}
.TicketPublicMenu-Container ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.TicketPublicMenu-Container ul li {
  display: flex;
  gap: 8px;
  padding: 9px 10px;
  cursor: pointer;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.TicketPublicMenu-Container ul li:hover {
  border-radius: 8px;
  background: #f9fafa;
}
.TicketChatMenu-Container {
  position: absolute;
  right: 0%;
  width: 226px;
  top: 120%;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 25px 16px;
  z-index: 1;
}
.TicketChatMenu-Container ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.TicketChatMenu-Container ul p {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.TicketChatMenu-Container ul li {
  display: flex;
  gap: 8px;
  padding: 8px 0px;
  cursor: pointer;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.TicketChatMenu-Container ul li:hover {
  border-radius: 8px;
  background: #f9fafa;
}
.TicketMerge-Card-Container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 16px;
}
.TicketMerge-Card01 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.TicketMerge-Card02 {
  display: flex;
  margin-top: 18px;
  gap: 8px;
}
.chatSelect-text01 {
  color: #405261;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 180% */
}
.hashnumber {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.opentag001 {
  color: #405261;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 150% */
}
.Brooklyn_simons {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.alma_text {
  color: #556575;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.cnattext {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  margin-top: 7px;
}
.Ticket-Main-SideBar {
  width: 33em;
  height: 100vh;
  overflow-y: auto;
  max-height: calc(100vh - 64px);
  background: #fff;
  border-left: 1px solid #e5e9ec;
  /* box-shadow: 0px 4px 80px 0px rgba(6, 21, 34, 0.1); */
  padding: 24px;
  transition: transform 0.3s ease;
  /* z-index: 1; */
}
.Ticket-Main-SideBar--open {
  transform: translateX(0);
}
.Ticket-Main-SideBar--closed {
  transform: translateX(-100%);
}
.ticketChagnetext {
  color: #148dfd;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}

.AssignToMeButton-container {
  margin-top: 10px;
}

.AssignToMeButton {
  width: 100%;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}

.editSubjectInput {
  height: 32px;
  max-width: 272px;
}
.NoGroupSelectedMessage {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  font-weight: 500;
  font-size: 14px;
  color: #405261;
  text-align: center;
  width: 100%;
  padding: 0 8px;
}
.buttonstyle-Group {
  width: 112px;
  height: 40px;

  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  border: none;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.buttonstyle-Group:not(:disabled):hover {
  background-color: #0077cc;

  outline: none;
}
.buttonstyle-Group:disabled {
  background: #f9fafa;
  color: #93a1b0;
  border: 1px solid #c5ced6;
  cursor: not-allowed;
}
.group-list-item {
  display: flex;
  align-items: center;
  padding: 0px 8px;
  height: 56px;
  margin-bottom: 8px;
  cursor: pointer;
  border-radius: 8px;
  background: #fff;
}
.group-list-item.selected {
  background: #f3fbff;
  border: 1px solid #148dfd;
}

.group-list-details {
  margin-left: 12px;
  flex: 1;
}

.group-title {
  font-weight: 500;
  color: #061522;
  font-size: 14px;
  font-family: "Inter";
  text-transform: capitalize;
  line-height: 18px;
}

.group-members {
  font-size: 14px;
  font-weight: 400;
  font-family: "Inter";
  color: #405261;
  line-height: 18px;
  margin-top: 3px;
}
.no-search-wrapper {
  margin-top: 20px;
}

.popup-content {
  width: 100%;
  margin-top: 16px;
}

.selected-group-chips {
  border: 1px solid #d5dce1;
  border-radius: 8px;
  min-height: 40px;
  max-height: 100px;
  overflow-y: auto;
  padding: 0px 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 16px;
  background-color: #fff;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

.no-groups-selected {
  color: #c5ced6;
  font-size: 14px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  line-height: 24px;
  align-self: center;
}

.group-scroll-container {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 16px;
  padding-right: 4px;
  margin-right: -4px;
}

.button-right {
  margin-top: 20px;
  justify-content: flex-end;
}
.loading-spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}
.customer-input-Search {
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/TicketSectionComponents/TicketChatSection/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;AACjC;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;AACjC;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,uDAAuD;EACvD,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;;EAEZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;;EAEzB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;;EAEtB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,WAAW;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;AACd","sourcesContent":[".TicketChat-Main-Container {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.TicketChat-Container {\r\n  display: flex;\r\n  width: 100%;\r\n  height: calc(100vh - 97px);\r\n  overflow: hidden;\r\n}\r\n.TicketChat-Main-HeaderContainer {\r\n  padding: 0px 0px 0px 24px;\r\n  border-bottom: 1px solid #e5e9ec;\r\n  background: rgba(255, 255, 255, 0.4);\r\n  backdrop-filter: blur(15px);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.TicketMessageInput-Container-MainScreen {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n.TicketChat-Main-UpperSection {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.TicketChat-upperright {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 6px;\r\n}\r\n.TicketChat-upperright span {\r\n  color: #405261;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 12px; /* 85.714% */\r\n}\r\n.TicketArrow-Container {\r\n  margin-left: 24px;\r\n  display: flex;\r\n  gap: 16px;\r\n  cursor: pointer;\r\n}\r\n.TicketHeading-Container {\r\n  margin-top: 12px;\r\n}\r\n.Ticketguy-heading {\r\n  color: #061522;\r\n  font-size: 24px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 29px;\r\n}\r\n.TicketKenzi {\r\n  margin-top: 8px;\r\n  color: #405261;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 16px; /* 85.714% */\r\n}\r\n.TicketHeading-SecondContainer {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding-right: 32px;\r\n}\r\n.TicketOpen-container {\r\n  border-radius: 5px;\r\n  border: 1px solid #148dfd;\r\n  background: #f3fbff;\r\n  padding: 7px 9px;\r\n  height: 27px;\r\n}\r\n\r\n.TicketHeadingOpen-Container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n.TicketHeadingOpen-Container span {\r\n  color: #061522;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 12px; /* 80% */\r\n}\r\n\r\n.truncate {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 200px;\r\n}\r\n.ChatTicketLogo-Container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  cursor: pointer;\r\n}\r\n.TicketPublicMenu-Container {\r\n  position: absolute;\r\n  right: 0%;\r\n  width: 184px;\r\n  top: 120%;\r\n  border-radius: 8px;\r\n  border: 1px solid #d5dce1;\r\n  background: #fff;\r\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\r\n  padding: 8px 11px;\r\n  z-index: 1;\r\n}\r\n.TicketPublicMenu-Container ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.TicketPublicMenu-Container ul li {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 9px 10px;\r\n  cursor: pointer;\r\n  color: #405261;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n}\r\n.TicketPublicMenu-Container ul li:hover {\r\n  border-radius: 8px;\r\n  background: #f9fafa;\r\n}\r\n.TicketChatMenu-Container {\r\n  position: absolute;\r\n  right: 0%;\r\n  width: 226px;\r\n  top: 120%;\r\n  border-radius: 8px;\r\n  border: 1px solid #d5dce1;\r\n  background: #fff;\r\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\r\n  padding: 25px 16px;\r\n  z-index: 1;\r\n}\r\n.TicketChatMenu-Container ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.TicketChatMenu-Container ul p {\r\n  color: #405261;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n}\r\n.TicketChatMenu-Container ul li {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 8px 0px;\r\n  cursor: pointer;\r\n  color: #405261;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n}\r\n.TicketChatMenu-Container ul li:hover {\r\n  border-radius: 8px;\r\n  background: #f9fafa;\r\n}\r\n.TicketMerge-Card-Container {\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e9ec;\r\n  background: #fff;\r\n  padding: 16px;\r\n}\r\n.TicketMerge-Card01 {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.TicketMerge-Card02 {\r\n  display: flex;\r\n  margin-top: 18px;\r\n  gap: 8px;\r\n}\r\n.chatSelect-text01 {\r\n  color: #405261;\r\n  font-size: 10px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px; /* 180% */\r\n}\r\n.hashnumber {\r\n  color: #061522;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px; /* 128.571% */\r\n}\r\n.opentag001 {\r\n  color: #405261;\r\n  text-align: center;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 18px; /* 150% */\r\n}\r\n.Brooklyn_simons {\r\n  color: #061522;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 18px; /* 128.571% */\r\n}\r\n.alma_text {\r\n  color: #556575;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px; /* 128.571% */\r\n}\r\n.cnattext {\r\n  color: #061522;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px; /* 128.571% */\r\n  margin-top: 7px;\r\n}\r\n.Ticket-Main-SideBar {\r\n  width: 33em;\r\n  height: 100vh;\r\n  overflow-y: auto;\r\n  max-height: calc(100vh - 64px);\r\n  background: #fff;\r\n  border-left: 1px solid #e5e9ec;\r\n  /* box-shadow: 0px 4px 80px 0px rgba(6, 21, 34, 0.1); */\r\n  padding: 24px;\r\n  transition: transform 0.3s ease;\r\n  /* z-index: 1; */\r\n}\r\n.Ticket-Main-SideBar--open {\r\n  transform: translateX(0);\r\n}\r\n.Ticket-Main-SideBar--closed {\r\n  transform: translateX(-100%);\r\n}\r\n.ticketChagnetext {\r\n  color: #148dfd;\r\n  font-family: Inter;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px;\r\n  text-decoration-line: underline;\r\n  text-decoration-style: solid;\r\n  text-decoration-skip-ink: none;\r\n  text-decoration-thickness: auto;\r\n  text-underline-offset: auto;\r\n  text-underline-position: from-font;\r\n  cursor: pointer;\r\n}\r\n\r\n.AssignToMeButton-container {\r\n  margin-top: 10px;\r\n}\r\n\r\n.AssignToMeButton {\r\n  width: 100%;\r\n  height: 40px;\r\n  flex-shrink: 0;\r\n  border-radius: 8px;\r\n  border: 1px solid #d5dce1;\r\n  background: #fff;\r\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\r\n  color: #405261;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.editSubjectInput {\r\n  height: 32px;\r\n  max-width: 272px;\r\n}\r\n.NoGroupSelectedMessage {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 32px;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  color: #405261;\r\n  text-align: center;\r\n  width: 100%;\r\n  padding: 0 8px;\r\n}\r\n.buttonstyle-Group {\r\n  width: 112px;\r\n  height: 40px;\r\n\r\n  border-radius: 8px;\r\n  border: 1px solid #d5dce1;\r\n  background: #148dfd;\r\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\r\n  border: none;\r\n  color: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 18px;\r\n  cursor: pointer;\r\n}\r\n.buttonstyle-Group:not(:disabled):hover {\r\n  background-color: #0077cc;\r\n\r\n  outline: none;\r\n}\r\n.buttonstyle-Group:disabled {\r\n  background: #f9fafa;\r\n  color: #93a1b0;\r\n  border: 1px solid #c5ced6;\r\n  cursor: not-allowed;\r\n}\r\n.group-list-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0px 8px;\r\n  height: 56px;\r\n  margin-bottom: 8px;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n}\r\n.group-list-item.selected {\r\n  background: #f3fbff;\r\n  border: 1px solid #148dfd;\r\n}\r\n\r\n.group-list-details {\r\n  margin-left: 12px;\r\n  flex: 1;\r\n}\r\n\r\n.group-title {\r\n  font-weight: 500;\r\n  color: #061522;\r\n  font-size: 14px;\r\n  font-family: \"Inter\";\r\n  text-transform: capitalize;\r\n  line-height: 18px;\r\n}\r\n\r\n.group-members {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  font-family: \"Inter\";\r\n  color: #405261;\r\n  line-height: 18px;\r\n  margin-top: 3px;\r\n}\r\n.no-search-wrapper {\r\n  margin-top: 20px;\r\n}\r\n\r\n.popup-content {\r\n  width: 100%;\r\n  margin-top: 16px;\r\n}\r\n\r\n.selected-group-chips {\r\n  border: 1px solid #d5dce1;\r\n  border-radius: 8px;\r\n  min-height: 40px;\r\n  max-height: 100px;\r\n  overflow-y: auto;\r\n  padding: 0px 14px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n  gap: 4px;\r\n  margin-bottom: 16px;\r\n  background-color: #fff;\r\n\r\n  scrollbar-width: none; /* Firefox */\r\n  -ms-overflow-style: none; /* IE 10+ */\r\n}\r\n\r\n.no-groups-selected {\r\n  color: #c5ced6;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  font-family: \"Inter\", sans-serif;\r\n  line-height: 24px;\r\n  align-self: center;\r\n}\r\n\r\n.group-scroll-container {\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  margin-top: 16px;\r\n  padding-right: 4px;\r\n  margin-right: -4px;\r\n}\r\n\r\n.button-right {\r\n  margin-top: 20px;\r\n  justify-content: flex-end;\r\n}\r\n.loading-spinner-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100px;\r\n}\r\n.customer-input-Search {\r\n  height: 40px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
